"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneField = void 0;
const react_1 = __importStar(require("react"));
// Common countries. Add more as needed.
const COUNTRIES = [
    { flag: '🇮🇳', name: 'India', dial: '91' },
    { flag: '🇺🇸', name: 'United States', dial: '1' },
    { flag: '🇬🇧', name: 'United Kingdom', dial: '44' },
    { flag: '🇦🇺', name: 'Australia', dial: '61' },
    { flag: '🇨🇦', name: 'Canada', dial: '1' },
    { flag: '🇸🇬', name: 'Singapore', dial: '65' },
    { flag: '🇦🇪', name: 'United Arab Emirates', dial: '971' },
    { flag: '🇸🇦', name: 'Saudi Arabia', dial: '966' },
    { flag: '🇶🇦', name: 'Qatar', dial: '974' },
    { flag: '🇴🇲', name: 'Oman', dial: '968' },
    { flag: '🇰🇼', name: 'Kuwait', dial: '965' },
    { flag: '🇲🇾', name: 'Malaysia', dial: '60' },
    { flag: '🇮🇩', name: 'Indonesia', dial: '62' },
    { flag: '🇵🇭', name: 'Philippines', dial: '63' },
    { flag: '🇹🇭', name: 'Thailand', dial: '66' },
    { flag: '🇻🇳', name: 'Vietnam', dial: '84' },
    { flag: '🇭🇰', name: 'Hong Kong', dial: '852' },
    { flag: '🇯🇵', name: 'Japan', dial: '81' },
    { flag: '🇨🇳', name: 'China', dial: '86' },
    { flag: '🇰🇷', name: 'South Korea', dial: '82' },
    { flag: '🇱🇰', name: 'Sri Lanka', dial: '94' },
    { flag: '🇳🇵', name: 'Nepal', dial: '977' },
    { flag: '🇧🇩', name: 'Bangladesh', dial: '880' },
    { flag: '🇵🇰', name: 'Pakistan', dial: '92' },
    { flag: '🇲🇻', name: 'Maldives', dial: '960' },
    { flag: '🇩🇪', name: 'Germany', dial: '49' },
    { flag: '🇫🇷', name: 'France', dial: '33' },
    { flag: '🇮🇹', name: 'Italy', dial: '39' },
    { flag: '🇳🇱', name: 'Netherlands', dial: '31' },
    { flag: '🇮🇪', name: 'Ireland', dial: '353' },
    { flag: '🇸🇪', name: 'Sweden', dial: '46' },
    { flag: '🇨🇭', name: 'Switzerland', dial: '41' },
    { flag: '🇿🇦', name: 'South Africa', dial: '27' },
    { flag: '🇳🇿', name: 'New Zealand', dial: '64' },
];
const DEFAULT_DIAL = '91';
/**
 * Phone input. If `field.countryCodeKey` is set, renders an inline flag+dial
 * prefix that reads from and writes to that sibling key. The country code
 * is stored as the bare numeric string ("91"), never with a "+" prefix.
 *
 * Filters keystrokes on the number input to accept only digits and common
 * separators — pasted alphabetic characters get stripped.
 */
const PhoneField = ({ field, value, onChange, error, disabled, siblingData, onSiblingChange, }) => {
    const ccKey = field.countryCodeKey;
    const inlineCC = !!ccKey;
    // Read the current CC from siblings, normalising away a leading "+" if any.
    const rawCC = ccKey && siblingData ? String(siblingData[ccKey] ?? '').replace(/^\+/, '').trim() : '';
    const cc = rawCC || (inlineCC ? DEFAULT_DIAL : '');
    // Ensure the default gets written back so the payload has the code even if
    // the admin never touches the dropdown.
    const wroteDefaultRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!inlineCC || !ccKey)
            return;
        if (rawCC)
            return;
        if (wroteDefaultRef.current)
            return;
        wroteDefaultRef.current = true;
        (onSiblingChange || onChange)(ccKey, DEFAULT_DIAL);
    }, [inlineCC, ccKey, rawCC, onSiblingChange, onChange]);
    const clean = (raw) => raw.replace(/[^\d\s()\-]/g, '');
    const [ccOpen, setCcOpen] = (0, react_1.useState)(false);
    const boxRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!ccOpen)
            return;
        const close = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target))
                setCcOpen(false);
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [ccOpen]);
    const flagFor = (0, react_1.useMemo)(() => {
        // Multiple countries share dial codes (US/Canada = 1). Prefer the first
        // catalog entry that matches — good enough for the flag display.
        const hit = COUNTRIES.find((c) => c.dial === cc);
        return hit?.flag || '🏳️';
    }, [cc]);
    const handleCcSelect = (dial) => {
        setCcOpen(false);
        if (ccKey)
            (onSiblingChange || onChange)(ccKey, dial);
    };
    // In view / read-only mode, collapse the widget to a plain "+91 9876543210"
    // string. Keeps the country code + number in one line without any chrome.
    if (disabled) {
        const display = value
            ? `${inlineCC ? `+${cc || DEFAULT_DIAL} ` : ''}${value}`
            : '';
        return (react_1.default.createElement("div", { className: "field-group" },
            react_1.default.createElement("label", { className: "field-label" }, field.label),
            react_1.default.createElement("div", { className: "wf-phone-view" }, display || '—')));
    }
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label", htmlFor: field.key },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        inlineCC ? (react_1.default.createElement("div", { className: `wf-phone-inline${error ? ' error' : ''}` },
            react_1.default.createElement("div", { className: "wf-phone-cc", ref: boxRef },
                react_1.default.createElement("button", { type: "button", className: "wf-phone-cc-btn", onClick: () => !disabled && setCcOpen((s) => !s), disabled: disabled, "aria-label": "Country code" },
                    react_1.default.createElement("span", { className: "wf-phone-flag" }, flagFor),
                    react_1.default.createElement("span", { className: "wf-phone-code" }, cc || '—'),
                    react_1.default.createElement("span", { className: "wf-phone-caret" }, "\u25BE")),
                ccOpen && !disabled && (react_1.default.createElement("ul", { className: "wf-phone-cc-list", role: "listbox" }, COUNTRIES.map((c) => (react_1.default.createElement("li", { key: `${c.name}-${c.dial}`, role: "option", "aria-selected": c.dial === cc, className: `wf-phone-cc-option${c.dial === cc ? ' active' : ''}`, onClick: () => handleCcSelect(c.dial) },
                    react_1.default.createElement("span", { className: "wf-phone-flag" }, c.flag),
                    react_1.default.createElement("span", { className: "wf-phone-cc-name" }, c.name),
                    react_1.default.createElement("span", { className: "wf-phone-cc-dial" },
                        "+",
                        c.dial))))))),
            react_1.default.createElement("input", { id: field.key, type: "tel", inputMode: "tel", className: "wf-phone-input", name: field.key, value: value || '', onChange: (e) => onChange(field.key, clean(e.target.value)), placeholder: "Phone number", autoComplete: "tel-national", disabled: disabled }))) : (react_1.default.createElement("input", { id: field.key, type: "tel", inputMode: "tel", className: `field-input${error ? ' error' : ''}`, name: field.key, value: value || '', onChange: (e) => onChange(field.key, clean(e.target.value)), placeholder: "e.g. 9876543210", autoComplete: "tel", disabled: disabled })),
        field.tooltip && react_1.default.createElement("div", { className: "field-hint" }, field.tooltip),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.PhoneField = PhoneField;
